import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ServiceSection.css';
import { Link } from 'react-router-dom';

import service1 from '../../assets/corp-ev-3.JPG';
import service2 from '../../assets/btl.jpg';
import service3 from '../../assets/serv-2.jpg';
import service4 from '../../assets/serv-3.jpg';
import service5 from '../../assets/serv-4.jpg';
import service6 from '../../assets/serv-5.jpg';

import service9 from '../../assets/serv-6.jpg';
import service10 from '../../assets/serv-7.jpg';
const services = [
  {
    title: 'Corporate Events',
    img: service1,
    desc: 'We manage corporate events end-to-end, including R&Rs, annual days, team outings, and celebration parties.',
    link: '/services/corporate-parties',
  },
  {
    title: 'BTL and ATL Activation',
    img: service2,
    desc: 'We specialize in both BTL and ATL activities—from on-ground activations and branding.',
    link: '/services/marketing-events',
  },
  {
    title: 'Artist Management',
    img: service3,
    desc: 'Creative and customized decor solutions to bring your event vision to life with elegance and style.',
    link: '/services/SocialEventsDetails',
  },
  {
    title: 'Venue Management',
    img: service4,
    desc: 'Engaging and interactive event activities tailored to captivate your audience and enhance participation.',
    link: '/services/EntertainmentEventsDetails',
  },
  {
    title: 'Event Production',
    img: service5,
    desc: 'Seamless production including sound, lighting, stage, and tech — all handled by our expert team.',
    link: '/services/EventProductionDetails',
  },
  {
    title: 'Event Activities',
    img: service6,
    desc: 'From celebrities to niche talent, we connect you with artists who elevate your event experience.',
    link: '/services/OfflineMarketingDetails',
  },
 
  
  {
    title: 'Event Decoration ',
    img: service9,
    desc: 'Comprehensive wedding planning services designed to make your big day stress-free and unforgettable.',
    link: '/services/HangerDetails',
  },
  {
    title: 'Wedding Management',
    img: service10,
    desc: 'Comprehensive wedding planning services designed to make your big day stress-free and unforgettable.',
    link: '/services/WeddingManagementDetails',
  },
   
];




const getAnimationClass = (index) => {
  if (index % 3 === 0) return 'slide-in-left';
  if (index % 3 === 1) return 'slide-in-bottom';
  return 'slide-in-right';
};

const ServiceCard = ({ title, img, desc, link, animation }) => (
  <div className={`col-md-4 mb-4 animate-card ${animation}`}>
    <div className="card service-card shadow-sm h-100">
      <div className="image-wrapper">
        <img src={img} className="card-img-top service-image" alt={title} />
      </div>
      <div className="card-body text-center">
        <h5 className="card-title text-uppercase">{title}</h5>
        <p className="card-text text-muted">{desc}</p>
        <Link to={link} className="btn gradient-btn">
          Learn More
        </Link>
      </div>
    </div>
  </div>
);



const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

const ServiceSection = () => {
  const serviceRows = chunkArray(services, 3);

  return (
    <div className="services-section py-5">
      <div className="container">
        <h2 className="section-title1 text-center mb-5">Our Best Services You</h2>
        {serviceRows.map((row, rowIndex) => (
          <div
            className={`row ${row.length < 3 ? 'justify-content-center' : ''}`}
            key={rowIndex}
          >
            {row.map((service, index) => (
              <ServiceCard
                key={index}
                {...service}
                animation={getAnimationClass(rowIndex * 3 + index)}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};


export default ServiceSection;
